import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { GetVendorClientDataPayload } from "../../payload/GetVendorClientData/GetVendorClientDataPayload";

const getVendorClientDataFetch = (state: ClientsState, action: PayloadAction<GetVendorClientDataPayload>) => {
    state.isLoading = true;
}

export default getVendorClientDataFetch;